import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { toBanglaNumber, formatCurrency } from '../../lib/utils';
import { ArrowLeft, Phone, CheckCircle2 } from 'lucide-react';
import { KioskScreen } from '../../components/kiosk/KioskScreen';
export function OtpVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    quantity = 1,
    total = 20,
    gateway = 'bkash'
  } = location.state || {};
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timeLeft, setTimeLeft] = useState(60);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  useEffect(() => {
    if (timeLeft > 0) {
      const t = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [timeLeft]);
  const handleOtpChange = (i: number, v: string) => {
    if (v.length > 1 || !/^\d*$/.test(v)) return;
    const next = [...otp];
    next[i] = v;
    setOtp(next);
    setError('');
    if (v && i < 5) document.getElementById(`otp-${i + 1}`)?.focus();
  };
  const handleKeyDown = (i: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) document.getElementById(`otp-${i - 1}`)?.focus();
  };
  const handleVerify = () => {
    const code = otp.join('');
    if (code.length < 6) {
      setError('সম্পূর্ণ OTP লিখুন');
      return;
    }
    if (code !== '123456') {
      setError('OTP সঠিক নয়, আবার চেষ্টা করুন');
      return;
    }
    setSuccess(true);
    setTimeout(() => navigate('/processing', {
      state: {
        quantity,
        total,
        gateway
      }
    }), 800);
  };
  const isBkash = gateway === 'bkash';
  const gColor = isBkash ? '#e2136e' : '#f7931e';
  const gName = isBkash ? 'বিকাশ' : 'নগদ';
  return <KioskScreen data-id="element-488">
      <main className="flex-1 min-h-0 flex items-center justify-center px-6 py-3" data-id="element-489">
        <div className="w-full max-w-xl bg-white/95 backdrop-blur-md rounded-3xl shadow-xl border border-white/80 p-6" data-id="element-490">
          {success ? <div className="text-center py-6" data-id="element-491">
              <CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-3" data-id="element-492" />
              <h2 className="text-2xl font-bold text-slate-900" data-id="element-493">
                OTP যাচাই সফল হয়েছে
              </h2>
              <p className="text-slate-500 mt-1" data-id="element-494">
                পেমেন্ট প্রসেসিংয়ে যাওয়া হচ্ছে...
              </p>
            </div> : <>
              <div className="text-center mb-4" data-id="element-495">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-3" style={{
              backgroundColor: `${gColor}15`,
              color: gColor
            }} data-id="element-496">
                  <div className="w-7 h-7 rounded-md flex items-center justify-center" style={{
                backgroundColor: gColor
              }} data-id="element-497">
                    <span className="text-white font-bold text-xs" data-id="element-498">
                      {isBkash ? 'bK' : 'N'}
                    </span>
                  </div>
                  <span className="font-bold text-sm" data-id="element-499">{gName}</span>
                  <span className="text-slate-400" data-id="element-500">•</span>
                  <span className="font-bold text-slate-900" data-id="element-501">
                    {formatCurrency(total)}
                  </span>
                  <span className="text-slate-400" data-id="element-502">•</span>
                  <span className="text-sm" data-id="element-503">
                    {toBanglaNumber(quantity)} টিকিট
                  </span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-504">
                  OTP যাচাই করুন
                </h2>
                <p className="text-sm text-slate-500" data-id="element-505">
                  আপনার মোবাইল নম্বরে পাঠানো OTP কোডটি লিখুন
                </p>
              </div>

              <div className="space-y-4 mb-5" data-id="element-506">
                <div data-id="element-507">
                  <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-508">
                    মোবাইল নম্বর
                  </label>
                  <Input icon={<Phone className="w-4 h-4" data-id="element-510" />} type="tel" placeholder="01XXXXXXXXX" value={mobile} onChange={e => setMobile(e.target.value)} className="h-12 text-base" data-id="element-509" />
                </div>

                <div data-id="element-511">
                  <label className="block text-sm font-medium text-slate-700 mb-1.5 text-center" data-id="element-512">
                    ৬-ডিজিট OTP
                  </label>
                  <div className="flex justify-center gap-2" data-id="element-513">
                    {otp.map((d, i) => <input key={i} id={`otp-${i}`} type="text" inputMode="numeric" value={d} onChange={e => handleOtpChange(i, e.target.value)} onKeyDown={e => handleKeyDown(i, e)} className={`w-11 h-14 md:w-12 md:h-14 text-center text-2xl font-bold rounded-xl border-2 focus:outline-none focus:ring-0 transition-colors ${error ? 'border-destructive' : 'border-slate-200 focus:border-brand-coral'}`} data-id="element-514" />)}
                  </div>
                  {error && <p className="text-destructive text-center mt-2 text-sm font-medium" data-id="element-515">
                      {error}
                    </p>}
                  <p className="text-xs text-slate-400 text-center mt-2" data-id="element-516">
                    টেস্টের জন্য OTP: 123456
                  </p>
                </div>
              </div>

              <div className="space-y-2" data-id="element-517">
                <Button size="lg" className="w-full" onClick={handleVerify} data-id="element-518">
                  OTP যাচাই করুন
                </Button>
                <div className="flex justify-between items-center" data-id="element-519">
                  <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-id="element-520">
                    <ArrowLeft className="w-4 h-4 mr-1" data-id="element-521" /> পেছনে যান
                  </Button>
                  <Button variant="ghost" size="sm" className={timeLeft > 0 ? 'text-slate-400' : 'text-brand-coral'} disabled={timeLeft > 0} onClick={() => {
                setTimeLeft(60);
                setOtp(['', '', '', '', '', '']);
                setError('');
              }} data-id="element-522">
                    OTP পুনরায় পাঠান{' '}
                    {timeLeft > 0 && `(${toBanglaNumber(timeLeft)}s)`}
                  </Button>
                </div>
              </div>
            </>}
        </div>
      </main>
    </KioskScreen>;
}